import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import { string } from 'prop-types';
import { useGlobalUserListContext } from 'contexts/GlobalUserListContext'; 
import { LoadingIcon } from './Icons';
import NameAvatar from './NameAvatar';

function User({ userEmail, id, withIcon = false, className = "" }) {
  return id ? <UserById id={id} withIcon={withIcon} className={className} /> : <UserByEmail email={userEmail} withIcon={withIcon} className={className} />
}

function UserByEmail({ email, withIcon, className }) {
  const { getUserName, isLoading } = useGlobalUserListContext();

  const displayName = useMemo(() => getUserName(email), [email, getUserName]);
  
  return <RenderUser loading={isLoading} email={email} displayName={displayName} withIcon={withIcon} className={className} />
}

function UserById({ id, withIcon, className }) {
  const { getUserData, isLoading } = useGlobalUserListContext();

  const {email = id, displayName = id} = useMemo(() => getUserData(id), [id, getUserData]);
  
  return <RenderUser loading={isLoading} email={email} displayName={displayName} withIcon={withIcon} className={className} />
}

function RenderUser({ loading, email, displayName, withIcon, className }) {
  return (
    loading 
    ? <LoadingIcon />
    : <div className={className}>
      {withIcon && <NameAvatar className="m-r-xs" name={displayName} size="small" />}
      <Tooltip title={email} placement="top">{displayName}</Tooltip>
      </div>
  );
}

User.propTypes = {
  userEmail: string,
  id: string
}

export default User;
